import { Reveal } from "../components/Reveal";
import { IMG, TEAM_STATS } from "../data/content";

export const Team = () => (
  <section data-testid="team-section" id="team" className="py-20 lg:py-32">
    <div className="container-blum">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end mb-12">
        <div>
          <Reveal><p className="overline">Das Team</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
              Hinter jedem guten Boden stehen echte Menschen.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="text-[#6B6B73] text-lg leading-relaxed">
            Ein Familienbetrieb lebt von Gesichtern, Namen und Geschichten. Bei Blum beraten Sie
            keine Verkäufer, sondern ein eingespieltes Handwerksteam mit Leidenschaft – und der
            Verantwortung, den eigenen Nachwuchs genauso sorgfältig auszubilden.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="group relative overflow-hidden aspect-[3/2]">
          <img
            src={IMG.teamNormal}
            alt="Das Team von Fussboden Blum vor dem Firmengebäude"
            className="absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-700 ease-out group-hover:opacity-0 group-hover:scale-105"
          />
          <img
            src={IMG.teamJubel}
            alt="Das jubelnde Team von Fussboden Blum"
            className="absolute inset-0 w-full h-full object-cover opacity-0 scale-105 transition-[opacity,transform] duration-700 ease-out group-hover:opacity-100 group-hover:scale-100"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B30]/70 via-transparent to-transparent pointer-events-none" />
          <div className="absolute bottom-0 left-0 p-6 lg:p-10 pointer-events-none">
            <p className="font-script text-2xl lg:text-3xl text-[#D7C4B1]">Ihr Team vor Ort</p>
            <h3 className="font-display text-xl lg:text-3xl font-bold text-white mt-1">
              Das Team von Fussboden Blum
            </h3>
          </div>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
        {TEAM_STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div data-testid={`team-stat-${i}`} className="bg-white border border-[#E5E0D8] p-8 lift text-center sm:text-left">
              <p className="font-display text-4xl lg:text-5xl font-bold text-[#D32F2F] leading-none">{s.value}</p>
              <p className="text-[#6B6B73] mt-3">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
